<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div class="col">               
      <div class="row">
        <div class="col-md-12">
          <div class="form-label" >
            {{this.label}}
            <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span>
            <span *ngIf="this.tooltip != null" class="mt-1">
              <app-help-tooltip id="{{this.propertyId+'Tooltip'}}" [tooltipMessage]="this.tooltip"></app-help-tooltip>
            </span> 
          </div> 
        </div>
        <div *ngIf="this.subText != null" class="col-md-12">
          <div [innerHTML]="this.subText"></div>
        </div>
      </div>
      <div class="row mb-1 booleanFieldFix">       
          <div class="col">
            <label class="container-radio" for="{{this.propertyId}}True">Yes
            <input 
              id="{{this.propertyId}}True" 
              name="{{this.propertyName}}" 
              type="radio" 
              formControlName="{{this.propertyName}}" 
              value="{{this.values[0]}}"
              (click)="this.userAction('Y')">
              <span class="checkmark"></span></label>
          </div>     
          <div class="col">
            <label class="container-radio" for="{{this.propertyId}}False">No
            <input 
              id="{{this.propertyId}}False" 
              name="{{this.propertyName}}" 
              type="radio" 
              formControlName="{{this.propertyName}}" 
              value="{{this.values[1]}}"
              (click)="this.userAction('N')">
              <span class="checkmark"></span></label>
          </div>      
      </div>
    </div>
  </div>
</div>